export const blockIconsHardwareDisplaySettingsNew = (
	<span className='material-symbols-outlined'>display_settings</span>
);
